import { ExpandMore } from '@material-ui/icons'
import React, { Fragment, useState } from 'react'
import styled from 'styled-components'

import Link from '../atoms/link'
import theme from '../atoms/theme'
import { StyledH4 } from './footer'
import {
  StyledExpandMore,
  StyledNavigationItem,
  SubNavigationItem,
  SubNavigationItems,
} from './navigation-item'

const { breakpoints, colours, animation, font } = theme

interface FooterNavigationItemProps {
  menuItem: {
    label: string
    url: string
    items: Array<{
      label: string
      url: string
    }>
  }
}

const FooterStyledNavigationItem = styled(StyledNavigationItem)`
  align-items: flex-start;

  @media only screen and ${breakpoints.toNormalScreen} {
    align-items: center;
  }

  @media only screen and ${breakpoints.fromNormalScreen} {
    flex-basis: 22.2%;
    flex-direction: column;

    &:hover > a,
    &.current > a {
      color: currentColor;
      &::before {
        display: none;
      }
    }

    &:hover .sub-navigation {
      top: unset;
    }
  }

  .expand {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
`

const FooterSubNavigationItems = styled(SubNavigationItems)`
  background-color: unset;

  @media only screen and ${breakpoints.fromNormalScreen} {
    top: unset;
    position: relative;
    left: 0;
    opacity: 1;
    width: 100%;
  }
`

export const FooterSubNavigationItem = styled(SubNavigationItem)`
  a {
    padding: 0.8rem 0;

    @media only screen and ${breakpoints.fromNormalScreen} {
      padding: 0;
      font-weight: ${font.fontWeightNormal};
      line-height: 2.4rem;
      margin-bottom: 0.8rem;
      transition: color ${animation.defaultLength} ease-in-out;

      &:hover {
        color: ${colours.primary};
      }
    }
  }
`

const FooterStyledExpandMore = styled(StyledExpandMore)`
  height: 7.6rem;
`

const FooterNavigationItem = (
  props: FooterNavigationItemProps,
): JSX.Element => {
  const { menuItem } = props
  const [isActive, setIsActive] = useState(false)

  function toggleMenuActive(): void {
    event.preventDefault()
    setIsActive(!isActive)
  }

  return (
    <FooterStyledNavigationItem>
      <StyledH4
        className='expand'
        onClick={(): void => {
          toggleMenuActive()
        }}
      >
        <Link to={menuItem.url}>{menuItem.label}</Link>
        <FooterStyledExpandMore active={isActive}>
          <ExpandMore />
        </FooterStyledExpandMore>
      </StyledH4>
      {menuItem.items && menuItem.items.length > 0 && (
        <Fragment>
          <FooterSubNavigationItems
            active={isActive}
            className='sub-navigation'
          >
            {menuItem.items.map((subMenuItem) => {
              // Use a unique key generated from both label and URL
              const uniqueKey = `${subMenuItem.label}-${subMenuItem.url}`
              return (
                <FooterSubNavigationItem key={uniqueKey}>
                  <Link to={subMenuItem.url}>{subMenuItem.label}</Link>
                </FooterSubNavigationItem>
              )
            })}
          </FooterSubNavigationItems>
        </Fragment>
      )}
    </FooterStyledNavigationItem>
  )
}

export default FooterNavigationItem
